import classNames from 'classnames';
import { Button } from '@/components/atoms/Button';
import { GoogleAnalyticsData } from '@/types/globals';

export interface TextLinkProps {
	testId?: string;
	onClick?: () => void;
	iconRender?: (className: string) => React.ReactNode;
	iconPosition?: 'left' | 'right';
	textSize?: 'sm' | 'base' | 'lg' | 'xl' | '2xl';
	children: string | React.ReactNode;
	buttonData?: GoogleAnalyticsData;
}

const TextLink = (props: TextLinkProps) => {
	const {
		testId = 'TextLink',
		onClick,
		iconRender,
		iconPosition,
		textSize = 'base',
		children,
		buttonData,
	} = props;

	const smallMargin = textSize === 'sm' || textSize === 'base';
	const largeMargin =
		textSize === 'lg' || textSize === 'xl' || textSize === '2xl';

	const iconStyles = classNames(
		'inline-block fill-sky-700 group-hover:fill-sky-800',
		{
			'ml-2': iconPosition === 'right' && smallMargin,
		},
		{
			'mr-2': iconPosition === 'left' && smallMargin,
		},
		{
			'ml-3': iconPosition === 'right' && largeMargin,
		},
		{
			'mr-3': iconPosition === 'left' && largeMargin,
		},
		{
			'h-[18px] w-[18px]': textSize === 'sm',
		},
		{
			'h-5 w-5': textSize === 'base',
		},
		{
			'h-6 w-6': textSize === 'lg' || textSize === 'xl',
		},
		{
			'h-7 w-7': textSize === '2xl',
		},
	);

	const textStyles = classNames(
		'!text-sky-700 hover:!text-sky-800',
		{
			'text-sm': textSize === 'sm',
		},
		{ 'text-base': textSize === 'base' },
		{
			'text-lg': textSize === 'lg',
		},
		{
			'text-xl': textSize === 'xl',
		},
		{
			'text-2xl': textSize === '2xl',
		},
	);

	const icon = iconRender?.(iconStyles);

	return (
		<div className="group" data-testid={testId}>
			<Button
				variant="text"
				className={classNames(textStyles, 'flex items-center')}
				onClick={onClick}
				data={buttonData}
			>
				{iconPosition === 'left' && icon}
				{children}
				{iconPosition === 'right' && icon}
			</Button>
		</div>
	);
};

export default TextLink;
